import { Buffer } from 'buffer'

export const decodeId = (id: string): string => {
  return Buffer.from(id, 'base64').toString().split(':')[1]
}

type ValidTargets = 'UserBetHistory' | 'User' | 'BetSlip'

export const encodeId = (target: ValidTargets, id: string): string => {
  return Buffer.from(`${target}:${id}`).toString('base64')
}
